import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Button from "../../components/common/button";
import AuthLayout from "../authLayout";
import { signIn, authProfile } from "../../utils/router/constant";
import Checkbox from "../../components/common/FormFields/checkbox";
import { useForm } from "react-hook-form";
import Input from "../../components/common/FormFields/input";
import { toast } from "react-toastify";
import api, { api_strapi } from "../../utils/interface";
import "./index.scss";
import {
  getCodeFromUrl,
  getParamsFromURL,
  setParamsInURL,
} from "../../utils/helper";
import AgDetail from "../authLayout/agDetail";
import LegalDocument from "../../components/legalDocumentModal";
import { openModal } from "../../store/slices/commonSlice";

const SignUp = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [mobile, setMobile] = useState(null);
  const codeFromUrl = getCodeFromUrl();
  const [show, setShow] = useState(false);
  const [documentData, setDocumentData] = useState([]);

  useEffect(() => {
    const fetchCode = async () => {
      await getParamsFromURL(location).then((params) => {
        if (params) {
          const mobile = params["mobile"];
          setMobile(parseInt(mobile));
        } else {
          console.error("No parameters found");
        }
      });
    };
    fetchCode();
  }, [location]);

  const {
    control,
    getValues,
    reset,
    formState: { errors, isValid },
  } = useForm({
    mode: "onChange",
  });
  const handleSendOtp = async () => {
    const fd = new FormData();
    let mobile = getValues("mobile");
    fd.append("mobile", mobile);
    fd.append("fromAction", "signup");
    fd.append("baseUrl", codeFromUrl);
    // if(!mobile) {
    //   mobile = await getParamsFromURL(location, "mobile");
    // }
    // Set the query parameters
    // const paramObject = {
    //   name: fullName,
    //   email: email,
    // }
    const params = await setParamsInURL(location, { mobile: mobile });
    try {
      await api.post(`/agsp/useraccount/sendOTP`, fd).then(() => {
        // if (!queryParams.get("mobile")) {
        //   queryParams.set("mobile", mobile);
        //   navigate(`${location.pathname}?${queryParams.toString()}`);
        //   reset();
        // } else {
        //   navigate(`${authProfile}?${queryParams.toString()}`);
        // }
        navigate(`${location.pathname}?${params}`);
        reset();
      });
    } catch (err) {
      toast.error(err.response?.data?.error_message || "An error occurred");
    }
  };

  const onSubmitOTP = async (e) => {
    e.preventDefault();
    const fd = new FormData();
    const otp = getValues("otp");
    const from_action = "signup";
    fd.append("mobile", mobile);
    fd.append("OTP", otp);
    fd.append("from_action", from_action);
    fd.append("baseUrl", codeFromUrl);
    const params = await setParamsInURL(location, { mobile: mobile });
    try {
      const res = await api.post(`/agsp/useraccount/verifyOTP`, fd);
      if (res.status === 200 && res.data.type === "success") {
        toast.success(res.data.message);
        navigate(`${authProfile}?${params}`);
      } else {
        toast.error(res.data.error_message);
      }
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        error.response.data.error_message
      ) {
        toast.error(error.response.data.error_message);
      } else {
        toast.error("Invalid OTP");
      }
    }
  };

  const OpenModal = async (value) => {
    const getTermsAndCondition = async () => {
      try {
        const response = await api_strapi.get(
          `/terms-and-conditions?filters[slug][$eq]=${value}-${codeFromUrl}&populate=termsAndCondition`
        );

        if (response && response.status === 200) {
           console.log("--------->", response);
           setDocumentData(response?.data[0]?.attributes);
         }
      } catch (error) {
        console.error("error fetching document", error);
      }
    };
    getTermsAndCondition();

    setShow(true);
  };

  const closeModal = () => {
    setShow(false);
  };

  return (
    <AuthLayout>
      <div className="auth--form--wrapper">
        <AgDetail />
        <h1 className="auth--title">Welcome! Sign Up into your account</h1>
        <p className="auth--subtitle">
          Sign Up to manage your insurance policies with ease
        </p>
        <form noValidate autoComplete="off">
          <div className="auth--form">
            {!mobile ? (
              <div className="auth--form">
                <Input
                  type="tel"
                  placeholder="Mobile Number"
                  name="mobile"
                  rules={{
                    required: {
                      value: true,
                      message: "Required field",
                    },
                    pattern: {
                      value: /^[0-9]{10}$/,
                      message: "Invalid Mobile Number",
                    },
                    minLength: {
                      value: 10,
                      message: "Minimum length should be 10",
                    },
                    maxLength: {
                      value: 10,
                      message: "Maximum length should not exceed 10",
                    },
                  }}
                  control={control}
                  errors={errors}
                  maxLength={10}
                  minLength={10}
                  // inputMode="numeric"
                  onInput={(e) => {
                    e.target.value = e.target.value.replace(/[^0-9]/g, ""); // Remove non-numeric characters
                  }}
                />
                {!mobile && (
                  <div className="checkbox-container">
                    <Checkbox
                      // label="I agree to the Terms and Conditions"
                      rules={{
                        required: true,
                      }}
                      className="checkbox-style"
                      name="terms"
                      control={control}
                      errors={errors}
                      options={[
                        {
                          name: "terms",
                          label: (
                            <>
                              I agree to the{" "}
                              <span
                                target="_blank"
                                rel="noopener noreferrer"
                                className="link-style"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  OpenModal("terms-and-conditions");
                                }}
                                style={{ cursor: "pointer", color: "blue" }}
                              >
                                Terms and Conditions
                              </span>{" "}
                              and{" "}
                              <span
                                target="_blank"
                                rel="noopener noreferrer"
                                className="link-style"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  OpenModal("privacy-policy");
                                }}
                                style={{ cursor: "pointer", color: "blue" }}
                              >
                                Privacy Policy
                              </span>
                            </>
                          ),
                        },
                      ]}
                    />
                  </div>
                )}
                <Button
                  type="button"
                  variant="primary"
                  label="Send Otp"
                  disabled={!isValid}
                  onClick={(e) => handleSendOtp(e)}
                />
              </div>
            ) : (
              <div className="auth--form">
                <Input
                  type="tel"
                  placeholder="OTP"
                  name="otp"
                  rules={{
                    required: {
                      value: true,
                      message: "Required field",
                    },
                    pattern: {
                      value: /^\d+$/,
                      message: "Invalid OTP",
                    },
                    minLength: {
                      value: 4,
                      message: "Minimum length should be 4",
                    },
                    maxLength: {
                      value: 4,
                      message: "Maximum length should not exceed 4",
                    },
                  }}
                  control={control}
                  errors={errors}
                  onInput={(e) => {
                    e.target.value = e.target.value.replace(/[^0-9]/g, ""); // Remove non-numeric characters
                  }}
                  maxLength={4}
                  minLength={4}
                />

                <Button
                  type="submit"
                  variant="primary"
                  label="Verify"
                  onClick={(e) => onSubmitOTP(e)}
                  disabled={!isValid}
                />
              </div>
            )}
          </div>
        </form>
        <div className="or--wrapper">
          <div className="line"></div>
          <span className="or--wrapper--text">or</span>
          <div className="line"></div>
        </div>
        <Button
          onClick={() => navigate(signIn)}
          type="button"
          variant="outlined"
          label="Sign In"
        />
      </div>
      <LegalDocument
        documentData={documentData}
        setShow={openModal}
        show={show}
        closeModal={closeModal}
      />
    </AuthLayout>
  );
};

export default SignUp;
